import {NgModule, ModuleWithProviders} from '@angular/core';
import {FocusDirective} from './focus.directive';


export class FocusModule {
  static forRoot (): ModuleWithProviders {
    return {
      ngModule: FocusModule
    };
  }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [FocusDirective],
  exports: [FocusDirective]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
